import React from 'react';
import { MapPin } from 'lucide-react';
const SERVICE_AREAS = ['Farmington Hills', 'Farmington', 'Commerce', 'Walled Lake', 'Wixom', 'Novi', 'Northville', 'Livonia', 'White Lake', 'Waterford', 'Milford', 'West Bloomfield'];
export function FamilyServiceAreas() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1146">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1147">
        <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1148">
          <MapPin className="w-4 h-4" data-id="element-1149" />
          Service Areas
        </div>
        <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1150">
          Family Classes for Southeast Michigan
        </h2>
        <p className="text-lg text-gray-warm mb-10 max-w-3xl mx-auto" data-id="element-1151">
          Storm Taekwondo serves families from across the area at our Farmington
          Hills location. If you're driving from any of these communities, we
          have family class times that work.
        </p>
        <div className="flex flex-wrap justify-center gap-3" data-id="element-1152">
          {SERVICE_AREAS.map(area => <span key={area} className="bg-off-white border border-subtle-gray text-ink px-4 py-2 rounded-full font-medium text-sm" data-id="element-1153">
              {area}
            </span>)}
        </div>
        <p className="text-gray-warm text-sm mt-8" data-id="element-1154">
          24786 Crestview, Farmington Hills, MI 48335 · Call 517-220-0621
        </p>
      </div>
    </section>;
}